/** 사용자 역할 */
export type UserRole =
  | 'GUARDIAN'
  | 'FACILITY'
  | 'CAREGIVER'
  | 'ADMIN'
  | 'SUPER_ADMIN'

/** 시설 유형 */
export type FacilityType =
  | 'NURSING_HOME'         // 요양원
  | 'NURSING_HOME_SMALL'   // 요양원 (소규모/공동생활가정)
  | 'DAY_CARE'             // 주간보호
  | 'SHORT_STAY'           // 단기보호
  | 'HOME_VISIT_CARE'      // 방문요양
  | 'HOME_VISIT_BATH'      // 방문목욕
  | 'HOME_VISIT_NURSING'   // 방문간호
  | 'WELFARE_EQUIPMENT'    // 복지용구
  | 'DEMENTIA_CARE'        // 치매전담
  | 'NURSING_HOSPITAL'     // 요양병원
  | 'HOME_CARE_CENTER'     // 재가복지센터
  | 'OTHER'                // 기타

/** 시설 유형 한글 라벨 */
export const FACILITY_TYPE_LABELS: Record<string, string> = {
  NURSING_HOME: '요양원',
  NURSING_HOME_SMALL: '요양원(소규모)',
  DAY_CARE: '주간보호',
  SHORT_STAY: '단기보호',
  HOME_VISIT_CARE: '방문요양',
  HOME_VISIT_BATH: '방문목욕',
  HOME_VISIT_NURSING: '방문간호',
  WELFARE_EQUIPMENT: '복지용구',
  DEMENTIA_CARE: '치매전담',
  NURSING_HOSPITAL: '요양병원',
  HOME_CARE_CENTER: '재가복지센터',
  OTHER: '기타',
}

/** 시설 유형을 한글로 변환하는 유틸 */
export function getFacilityTypeLabel(type: string): string {
  return FACILITY_TYPE_LABELS[type] || type
}

/**
 * 시설유형 → 지역 랜딩 URL 슬러그 (라우트/사이트맵과 동일한 정식 슬러그).
 *
 * <p>지역 랜딩 페이지(`/facilities/:sido/:sigungu/:type`)를 가진 6개 주요 유형만 포함한다.
 * 표시용 {@link FACILITY_TYPE_LABELS}(예: DAY_CARE→"주간보호")와 달리 URL은 정식 슬러그
 * (예: DAY_CARE→"주간보호센터")를 써야 한다. 이 맵은 다음과 반드시 일치해야 한다:
 * - 프론트 라우트: RegionalFacilityPage 의 TYPE_SLUG_TO_ENUM (역방향)
 * - 백엔드 사이트맵: SitemapService.typeSlugMap
 * 그 외 유형(단기보호/방문목욕 등)은 지역 랜딩이 없으므로 undefined → 유형 단계 링크 생략.
 */
export const FACILITY_TYPE_URL_SLUGS: Record<string, string> = {
  NURSING_HOME: '요양원',
  NURSING_HOME_SMALL: '공동생활가정',
  DAY_CARE: '주간보호센터',
  NURSING_HOSPITAL: '요양병원',
  DEMENTIA_CARE: '치매전담시설',
  HOME_VISIT_CARE: '방문요양',
}

/** 시설유형의 지역 랜딩 URL 슬러그. 랜딩 페이지가 없는 유형은 undefined. */
export function getFacilityTypeUrlSlug(type: string): string | undefined {
  return FACILITY_TYPE_URL_SLUGS[type]
}

/** 장기요양 등급 */
export type CareGrade = '1' | '2' | '3' | '4' | '5' | 'COGNITIVE'

/** 평가 등급 (A~E) */
export type EvaluationGrade = 'A' | 'B' | 'C' | 'D' | 'E'

/** 페이지네이션 정보 (Spring Page 구조와 호환) */
export interface PageInfo {
  page: number
  size: number
  totalElements: number
  totalPages: number
  /** @deprecated Spring Page는 last/first 사용 */
  hasNext?: boolean
  /** @deprecated Spring Page는 last/first 사용 */
  hasPrevious?: boolean
}

/** 정렬 옵션 */
export interface SortOption {
  field: string
  direction: 'ASC' | 'DESC'
}
